import { render, staticRenderFns } from "./Associantes.vue?vue&type=template&id=49673323"
import script from "./Associantes.vue?vue&type=script&lang=js"
export * from "./Associantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports